import React from "react";
import Accordion from "@carrier-io/air-react/Accordion";
import AccordionSummary from "@carrier-io/air-react/AccordionSummary";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import { Typography } from "@carrier-io/air-react";
import AccordionDetails from "@carrier-io/air-react/AccordionDetails";
import Box from "@carrier-io/air-react/Box";
import { DataError } from "../../../hooks/useBulkUsersCsvParser";

export const ParsersContentError = ({ error }: { error: DataError }) => {
  return (
    <Accordion>
      <AccordionSummary
        aria-controls="panel1a-content"
        expandIcon={<ExpandMoreOutlinedIcon />}
        expandIconPosition="right"
        id="panel1a-header"
        statusIndicatorType="error"
      >
        <Typography
          color="error.main"
          sx={{
            marginTop: "5px",
          }}
          variant="subtitle2"
        >
          Line {error.lineNumber}
        </Typography>
      </AccordionSummary>
      {error.errors.length && (
        <AccordionDetails
          sx={{
            padding: "0 0 0 8px",
          }}
        >
          <Typography
            sx={{
              margin: "5px 0 0 16px",
            }}
          >
            {error.errors.map((err) => (
              <Box
                key={err.property}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {Object.values(err.constraints || {}).map((c, i) => (
                  <Typography
                    variant="body2"
                    color="error.main"
                    key={err.property + i}
                    sx={{
                      marginTop: "5px",
                    }}
                  >
                    {c}
                  </Typography>
                ))}
              </Box>
            ))}
          </Typography>
        </AccordionDetails>
      )}
    </Accordion>
  );
};
